import { type FC, useState } from 'react'

import { AgentTrackPlayer } from '@liveHelper/components/OnCall/OnCall'
import { ASPECT_RATIO_LANDSCAPE } from '@oneToOne/shared/components/chat/constants'
import type { IAgoraRTCRemoteUser, ILocalVideoTrack } from 'agora-rtc-sdk-ng'

import { useBreakpoint } from '@core/components/Layout/Breakpoint/useBreakpoint'
import { isMobileWeb } from '@core/userAgent'
import { useScreenOrientation } from '@core/window/hooks'

import {
  CustomerAgoraTrackPlayer,
  CustomerAgoraTrackPlayerWrapper,
  OnCallVideoContainerWrapper,
} from './OnCallVideoContainer.styles'

interface OnCallVideoContainerProps {
  agentUser: IAgoraRTCRemoteUser | undefined
  localVideoTrack: ILocalVideoTrack | undefined
  displayMode: 'fullScreen' | 'minimized'
}

/**
 * Shared Component for rendering the video container for video calls.
 */
export const OnCallVideoContainer: FC<OnCallVideoContainerProps> = ({
  agentUser,
  displayMode,
  localVideoTrack,
}) => {
  const [isCustomerVideoEnlarged, setIsCustomerVideoEnlarged] = useState(false)
  const isMobileWebEnabled = isMobileWeb()
  const { width: containerWidth, height: containerHeight } = useBreakpoint()
  const doesContainerSupportLandscape =
    containerWidth / containerHeight > ASPECT_RATIO_LANDSCAPE
  const screenOrientation = useScreenOrientation()
  const isMinimized = displayMode === 'minimized'

  return (
    <OnCallVideoContainerWrapper
      isMobileWeb={isMobileWebEnabled}
      isMinimized={displayMode === 'minimized'}
      doesContainerSupportLandscape={doesContainerSupportLandscape}
    >
      <AgentTrackPlayer agentUser={agentUser} isMinimized={isMinimized} />
      <CustomerAgoraTrackPlayerWrapper
        onClick={() => setIsCustomerVideoEnlarged((prevState) => !prevState)}
        // rr-block is used to block the visitor video track from showing up
        // in the monitoring replay
        className="rr-block"
        isMobilePortrait={
          isMobileWebEnabled && screenOrientation === 'portrait'
        }
        isCustomerVideoEnlarged={isCustomerVideoEnlarged}
      >
        <CustomerAgoraTrackPlayer videoTrack={localVideoTrack} />
      </CustomerAgoraTrackPlayerWrapper>
    </OnCallVideoContainerWrapper>
  )
}
